import { ComplianceDocumentStatusTypes } from 'domain/shared/compliance';
import { COMPLIANCE_SIGNING_STATES } from 'domain/shared/compliance/report/constants';
import { EMPLOYEE_CONTRACT_TYPES_ALIASES } from 'domain/shared/employee';
import { ComplianceCoverageStatus, ComplianceCoverageStatusView, ComplianceDocumentStatusView } from './types';

export const COMPLIANCE_AUDIENCE_COVERAGE_BATCH_SIZE = 30;
export const PROJECT_SEARCH_PAGE_SIZE = 200;
export const ASSIGNMENTS_SEARCH_PAGE_SIZE = 30;

export const DEFAULT_ACTIVE_CONTRACT_TYPES = [
  EMPLOYEE_CONTRACT_TYPES_ALIASES.EC,
  EMPLOYEE_CONTRACT_TYPES_ALIASES.B2B,
  EMPLOYEE_CONTRACT_TYPES_ALIASES.CFS,
];

const UNPUBLISHED_DOCUMENT_INFO_MESSAGE = 'This document is unpublished. Statuses are not available yet.';
export const OUTDATED_UNPUBLISHED_DOCUMENT_INFO_MESSAGE =
  'This document has not been published. Statuses are unavailable.';

export const COMPLIANCE_COVERAGE_STATUS_VIEW: Record<ComplianceCoverageStatus, ComplianceCoverageStatusView> = {
  [ComplianceCoverageStatus.NOT_SIGNED]: {
    color: 'error',
    label: COMPLIANCE_SIGNING_STATES.NOT_SIGNED,
  },
  [ComplianceCoverageStatus.SIGNED]: {
    color: 'success',
    label: COMPLIANCE_SIGNING_STATES.SIGNED,
  },
  [ComplianceCoverageStatus.LOADING]: {
    color: 'default',
    label: 'Loading...',
  },
  [ComplianceCoverageStatus.UNAVAILABLE]: {
    color: 'default',
    label: 'Status unavailable',
  },
};

export const COMPLIANCE_DOCUMENT_BASE_STATUS_VIEW: Record<ComplianceDocumentStatusTypes, ComplianceDocumentStatusView> =
  {
    PUBLISHED: {
      label: 'Published',
      color: 'success',
      shouldLoadStatuses: true,
    },
    UNPUBLISHED: {
      label: 'Unpublished',
      color: 'default',
      shouldLoadStatuses: false,
      infoMessage: UNPUBLISHED_DOCUMENT_INFO_MESSAGE,
    },
  };
